(function () {
  function getJQ() {
    var $ = window.jQuery;
    return $ && $.fn && $.fn.slick ? $ : null;
  }

  function syncArrow(review, index, count) {
    if (!review) return;
    var arrow = review.querySelector('[data-lp-review-arrow]');
    if (!arrow) return;
    if (index >= count - 1) {
      arrow.classList.add('lp-fitness-levelup__review-arrow--back');
    } else if (index <= 0) {
      arrow.classList.remove('lp-fitness-levelup__review-arrow--back');
    }
    var isBack = arrow.classList.contains('lp-fitness-levelup__review-arrow--back');
    arrow.setAttribute('aria-label', isBack ? 'Previous review' : 'Next review');
  }

  function initSlider(slider) {
    var $ = getJQ();
    if (!$) return;
    var $slider = $(slider);
    if ($slider.hasClass('slick-initialized')) return;
    var review = slider.closest('.lp-fitness-levelup__review');

    $slider.on('init afterChange', function (event, slick, currentSlide) {
      syncArrow(review, currentSlide || 0, slick.slideCount);
    });

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      adaptiveHeight: false,
      speed: 400,
    });
  }

  function initAll() {
    if (!getJQ()) return false;
    document.querySelectorAll('[data-lp-review-slider]').forEach(initSlider);
    return true;
  }

  // Delegated click — fires regardless of when slick finishes initializing.
  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-lp-review-arrow]');
    if (!arrow) return;

    var $ = getJQ();
    if (!$) return;

    var review = arrow.closest('.lp-fitness-levelup__review');
    var slider = review && review.querySelector('[data-lp-review-slider]');
    if (!slider) return;

    var $slider = $(slider);
    if (!$slider.hasClass('slick-initialized')) return;

    var slick = $slider.slick('getSlick');
    var index = slick.currentSlide;
    var count = slick.slideCount;

    if (index >= count - 1) {
      $slider.slick('slickPrev');
    } else if (index <= 0) {
      $slider.slick('slickNext');
    } else if (arrow.classList.contains('lp-fitness-levelup__review-arrow--back')) {
      $slider.slick('slickPrev');
    } else {
      $slider.slick('slickNext');
    }
  });

  if (!initAll()) {
    window.addEventListener('load', initAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var slider = event.target.querySelector('[data-lp-review-slider]');
    if (slider) initSlider(slider);
  });
})();
